module.exports = __webpack_public_path__ + "img/generated-1772421298893.83b49a30.png";